export const CHECK_USER_LOGGED_IN_TO_META_MASK = "CHECK_USER_LOGGED_IN_TO_META_MASK";
export const UPDATE_USER_STRAPI_DETAILS = "UPDATE_USER_STRAPI_DETAILS";
export const UPDATE_USER_AVATAR = "UPDATE_USER_AVATAR";
export const LOGOUT_USER = "LOGOUT_USER";
export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";
export const UPDATE_CHAIN_STATUS = "UPDATE_CHAIN_STATUS";
export const RELOAD_REDUX_STATE = "RELOAD_REDUX_STATE";